import { CheckCircle2, Coins, Wallet2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { GameSelectionModal } from "./GameSelectionModal";
import ReactConfetti from "react-confetti";

const Verified = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [isGameModalOpen, setIsGameModalOpen] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Start confetti and remove after 5 seconds
    const timer = setTimeout(() => setShowConfetti(false), 10000);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {showConfetti && (
        <ReactConfetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          recycle={false}
          numberOfPieces={50}
          gravity={2}
          colors={[
            "#FFD700", // Gold
            "#FFA500", // Orange
            "#FF4500", // Red-Orange
            "#32CD32", // Lime Green
            "#00CED1", // Dark Turquoise
            "#4169E1", // Royal Blue
          ]}
        />
      )}

      <div className="py-8 md:py-16 flex flex-col items-center justify-center space-y-8 md:space-y-12 relative overflow-hidden px-4">
        {/* Background glow */}
        <div
          className="absolute inset-0 opacity-60 animate-in fade-in duration-1000"
          style={{ transform: "scale(1.5)" }}
        />

        {/* Success checkmark with ripple effect */}
        <div className="relative z-10">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center animate-in fade-in zoom-in duration-700">
            <CheckCircle2 className="w-10 h-10 md:w-12 md:h-12 text-white" />
          </div>
          <div className="absolute inset-0 w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 animate-ping opacity-20" />
        </div>

        {/* Enhanced typography section with hover effects */}
        <div className="text-center space-y-4 md:space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 z-10">
          <div className="space-y-2">
            <h2 className="text-2xl md:text-3xl font-semibold font-body text-gray-900 tracking-tight">
              You Are Verified!
            </h2>
            <p className="text-sm md:text-base text-gray-900/60 font-normal tracking-wide leading-relaxed">
              You're able to play our games.
            </p>
          </div>

          {/* <div className="pt-2">
            <p className="text-sm font-medium uppercase tracking-widest text-gray-400">
              Link wallets below
            </p>
          </div> */}
        </div>

        {/* Interactive button with hover effects */}
        <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300 z-10 w-full sm:w-auto">
          <Button
            variant="purple"
            className="group px-6 md:px-8 py-4 md:py-6 transition-all duration-300 text-sm font-medium tracking-wide w-full sm:w-auto"
            onClick={() => navigate("/wallet-management")}
          >
            <span className="inline-flex items-center gap-2 group-hover:translate-x-1 transition-transform duration-300">
              Link Wallets
              <Wallet2 className="w-4 h-4 opacity-100 transition-all duration-300" />
            </span>
          </Button>
          <Button
            variant="degen"
            className="group px-6 md:px-8 py-4 md:py-6 transition-all duration-300 text-sm font-medium tracking-wide w-full sm:w-auto"
            onClick={() => setIsGameModalOpen(true)}
          >
            <span className="inline-flex items-center gap-2 group-hover:translate-x-1 transition-transform duration-300">
              Play Games
              <Coins className="w-4 h-4 opacity-100 transition-all duration-300" />
            </span>
          </Button>
        </div>
      </div>

      <GameSelectionModal
        isOpen={isGameModalOpen}
        onClose={() => setIsGameModalOpen(false)}
      />
    </>
  );
};

export default Verified;
